/**
 * Generate QR code for study plan verification
 */

const QR_SERVER_BASE = import.meta.env.VITE_QR_SERVER_BASE_URL || 'https://api.qrserver.com/v1/create-qr-code/';

export interface QRCodeOptions {
  size?: number;
  format?: 'png' | 'svg';
  errorCorrection?: 'L' | 'M' | 'Q' | 'H';
}

/**
 * Generate QR code URL using QR Server API
 */
export function generateQRCodeUrl(
  data: string,
  options: QRCodeOptions = {}
): string {
  const {
    size = 300,
    format = 'png',
    errorCorrection = 'M',
  } = options;

  const params = new URLSearchParams({
    size: `${size}x${size}`,
    data,
    format,
    ecc: errorCorrection,
  });

  return `${QR_SERVER_BASE}?${params.toString()}`;
}

/**
 * Generate QR code for study plan verification link
 */
export function generateVerificationQR(approvalLink: string, options?: QRCodeOptions): string {
  const baseUrl = import.meta.env.VITE_BASE_URL || window.location.origin;
  const verificationUrl = `${baseUrl}/verify/${approvalLink}`;
  return generateQRCodeUrl(verificationUrl, options);
}

/**
 * Download QR code as image
 */
export async function downloadQRCode(url: string, filename: string = 'qr-code.png') {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error('Failed to download QR code:', error);
    throw error;
  }
}
